export class WidgetConstants {
    static WIDGET_DESCRIPTION_URL: any;
    public static readonly DATE_FORMAL_COMPACT = 'yyyyMMdd';
    public static readonly DATE_FORMAT_SIMPLE = 'yyyy-MM-dd';
    public static readonly DATE_FORMAT_LONG = 'yyyy-MM-dd hh:mm a';
    static CHART_COLORS_DEFAULT: any;
    static CHART_COLORS_GAUGE: any;
}